import "./style.scss";
import React, { useContext, useLayoutEffect, useRef, useEffect } from "react";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import { PrescriptionContextMemorySpace } from "../../../contexts/orden-medica/prescriptionContext";
import { myAxios, fetchLogs } from "../../../utils/fetch";
import { capitalize } from "../../../utils/capitalize";
import HeaderSearch from "./components/HeaderSearch";
import Desktop from "./components/Desktop";
import Mobile from "./components/Mobile";
import usePagination from "./hooks/usePagination";

const OrdenMedicaComponent = () => {
    const { user } = useContext(UserGlobalContextMemorySpace);
    const { setFamilyGroupList, setSearchText } = useContext(
        PrescriptionContextMemorySpace
    );
    const [customers, setCustomers] = React.useState([user.user.data.Customers]);
    const { obtenerResultados } = usePagination();
    const refBusqueda = useRef();

    const { activeKey, setActiveKey, currentIdSap } = useContext(
        PrescriptionContextMemorySpace
    );

    const toggleAccordion = (key) => {

        obtenerResultados(currentIdSap);

        setSearchText("");
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // useEffect(() => {
    //     toggleAccordion();
    // }, []);

    useEffect(() => {
        myAxios({
            url:
                process.env.REACT_APP_GATEWAY_QA +
                "/customers/api/v1/familiargroup/getfamiliargroupbyid",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                //USERTOKEN: user.user.data.Token,
                Authorization: `Bearer ${user.user.data.appToken}`,
            },
            data: {
                idCustomer: user.user.data.Customers.idCustomer,
            },
        })
            .then((response) => {
                const familyGroup = response.data.data.FamilyGroup.map((family) => {
                    return { id: family.idSap ?? "", name: capitalize(family.fullName) };
                });
                var temporalFamilyGroup = [
                    {
                        id: user.user.data.Customers.idSap,
                        name:
                            capitalize(user.user.data.Customers.firstName +
                            " " +
                            user.user.data.Customers.lastName),
                    },
                    ...familyGroup,
                ];
                setCustomers([...customers, ...response.data.data.FamilyGroup]);
                setFamilyGroupList(temporalFamilyGroup);
            })
            .catch((error) => { })
            .finally(() => {
                obtenerResultados(user.user.data.Customers.idSap);
            });
    }, []);

    return (
        <section className=" " ref={refBusqueda}>
            <div className="container" id="container-prescripcions">
                <div className="accordion" id="accordionExample">
                    {/* RECETAS VIGENTES */}
                    <div>
                        <div className="row mb-3">
                            <div className="col-lg-5 main-title-recetas">
                                <h2 className="section_hb_title title-results">
                                    <b
                                        id="headingOne"
                                        className="section_hb_title title_prescription"
                                    >
                                        Ordenes clínicas
                                    </b>
                                </h2>
                            </div>

                            <div className="col-lg-1"></div>
                        </div>

                        <div
                            id="collapseOne"
                            // className={`collapse ${activeKey === 0 ? "show" : ""}`}
                            aria-labelledby="headingOne"
                            data-parent="#accordionExample"
                        >
                            <div>
                                <HeaderSearch />
                            </div>
                            <div
                                class="d-block d-md-none w-100"
                                style={{ marginTop: "15px" }}
                            >
                                <Mobile />
                            </div>

                            <div class="d-none d-md-block w-100">
                                <Desktop />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OrdenMedicaComponent;